<template>
  <section class="py-5 container">
    <h5>Editar cotización</h5>
    <hr />
    <ArgonSnackbar
      title="Importante"
      description="Al momento de guardar se generará una nueva cotización independiente a la cual está editando. Ajuste el plazo y valor residual."
      color="warning"
      :fullWidth="true"
    />
    <LoadingSpinner v-if="!cotizacion" />
    <CotizacionArrendamientoForm
      :cotizacion="cotizacion"
      :cotizacionDetalle="cotizacionDetalle"
      v-else
    />
  </section>
</template>

<script setup>
import LoadingSpinner from "@/components/LoadingComponent.vue";
import ArgonSnackbar from "@/components/ArgonSnackbar.vue";
import CotizacionArrendamientoForm from "@/components/cotizacion/arrendamiento/form";
import { onMounted } from "vue";
import { useCotizacionUnidadEditar } from "@/composables/useCotizacionUnidad";
const {
  getCotizacion,
  cotizacion,
  cotizacionDetalle,
} = useCotizacionUnidadEditar();
onMounted(async () => {
  await getCotizacion();
});
</script>
